import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { snakeCase } from 'change-case';
import { NgTemplateOutlet } from '@angular/common';
import { EntityPrimaryAlertComponent } from './entity-primary-alert.component';
import { KeysPipe } from '../../../shared/pipes/keys.pipe';

@Component({
  templateUrl: './entity-has-dependencies-modal.component.html',
  selector: 'con-entity-has-dependencies-modal',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgTemplateOutlet, EntityPrimaryAlertComponent, KeysPipe],
})
export class EntityHasDependenciesModalComponent implements OnInit {
  @Input() entities: any;
  @Input() isBulk: boolean = false;
  @Input() entityName?: string;
  public enitityURLKey: string;

  constructor(public activeModal: NgbActiveModal) {}

  setEntities(entities: any) {
    this.entities = entities;
  }

  ngOnInit(): void {
    this.enitityURLKey = this.entityName ? snakeCase(this.entityName) : null;
  }
}
